<template>
  <div class="page-box">
    <Header />
    <!-- Banner 区 -->
    <div class="page-content bg-color-EAF1FA">
      <div class="top-box max-width-1920"
        :style="{ backgroundImage: `url(${require('@/assets/product/robot/LM200/banner.jpg')})` }">
        <div class="content-positioning" data-aos="fade-up" :style="contentStype">
          <div class="title-1" :style="titleStyle">AI 智能零售巡检机器人 LM200</div>
          <div class="title-2">专为无人零售店及中小商超打造<br>
            提供轻量化智能零售巡检解决方案</div>
          <div class="title-3" @click="openContactUs">
            申请试用
          </div>
        </div>
      </div>

    </div>

    <!-- 核心能力 -->
    <div class="capability-section" data-aos="fade-up">
      <div class="section-title-small">核心技术</div>
      <div class="section-subtitle">两大核心模块 打造商超专属轻量化巡检机器人</div>
      <div class="capability-grid">
        <div class="capability-card" v-for="(item, index) in capabilityList" :key="index">
          <img class="capability-icon" :src="item.icon" alt="">
          <div class="capability-name">{{ item.name }}</div>
          <div class="capability-desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>

    <div class="capability-section" data-aos="fade-up">
      <div class="section-title-small">核心卖点</div>
      <div class="section-subtitle">24 小时不间断巡检 全维度保障商超货架管理</div>
      <div class="capability-grid1">
        <div class="capability-card" v-for="(item, index) in featureList" :key="index">
          <img class="capability-icon" :src="item.icon" alt="">
          <div class="capability-name">{{ item.name }}</div>
          <div class="capability-desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>


    <!-- 技术特点 -->
    <div class="feature-section" data-aos="fade-up"
      :style="{ backgroundImage: `url(${require('@/assets/product/robot/LM200/img7.jpg')})` }">
    </div>


    <div class="flor3" data-aos="fade-up">
      <div class="f2-title">适配应用场景</div>
      <div class="f2-subtitle">聚焦零售商超领域 适配不同规模零售场景</div>

      <div class="scene-cards-container">
        <div class="scene-card-item" v-for="(scene, index) in sceneList" :key="index">
          <div class="f3-card">
            <img class="bgimg" :src="scene.icon"/>
            <div class="title">{{ scene.name }}</div>
            <div class="subtitle">{{ scene.desc }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部联系方式 -->
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import metaInfo from "@/common/util/metaInfo"

export default {
  metaInfo: metaInfo.lm200,
  components: {
    Header,
    Footer
  },
  data() {
    return {
      capabilityList: [
        { icon: require("@/assets/product/robot/LM200/icon1.svg"), name: '零售专用 AI 模型', desc: '针对商超商品深度优化，识别准确率 99.2%，可精准区分缺货、价签错误、陈列不规范等问题，效率提升 30% 以上。' },
        { icon: require("@/assets/product/robot/LM200/icon2.svg"), name: '测距与避障模块', desc: '多线激光雷达 + 视觉避障双传感，自主规划路径，最小避障距离 0.1 米，适配商超复杂环境，巡检覆盖率 100%。' },
      ],
      flowList: [
        { icon: '📤', name: '数据上传', desc: '支持多种格式' },
        { icon: '🔧', name: '数据处理', desc: '清洗、标注、增强' },
        { icon: '🎯', name: '模型训练', desc: '高效训练环境' },
        { icon: '✅', name: '模型部署', desc: '一键上线' }
      ],
      processList: [
        { icon: '📥', title: '数据上传', desc: '支持 CSV、JSON、Excel、图片、视频等多种格式，可通过 API 实时接入、文件批量上传或数据库直连同步。系统自动识别数据类型和结构，为后续处理做好准备。' },
        { icon: '🧹', title: '数据清洗与标注', desc: 'AI 自动检测并处理缺失值、异常值和重复数据。支持智能标注功能，可根据业务需求自动打标签，大幅提升数据准备效率。' },
        { icon: '🎓', title: '模型训练', desc: '提供可视化训练界面，支持分布式训练加速。自动超参数调优，降低模型开发门槛。训练过程实时监控，异常自动告警。' },
        { icon: '🚀', title: '模型部署', desc: '一键式部署到云端或边缘设备。支持多版本管理、A/B 测试和灰度发布。提供 API 接口，快速集成到业务系统。' }
      ],
      featureList: [
        { icon: require("@/assets/product/robot/LM200/icon3.svg"), name: '智能迎宾导购', desc: '多轮对话语音交互，主动问好并推荐商品，解答价格/位置等问题，提升购物体验与转化率。' },
        { icon: require("@/assets/product/robot/LM200/icon4.svg"), name: '自定义巡检路径', desc: '按需设置巡检路线与频次，热销区高频巡检，非核心区低频巡检，最大化巡检效率。' },
        { icon: require("@/assets/product/robot/LM200/icon5.svg"), name: '24h 巡检 + 夜间安防', desc: '白天巡检货架，夜间切换安防模式，红外夜视检测异常并推送报警信息至手机端。' },
        { icon: require("@/assets/product/robot/LM200/icon6.svg"), name: '货架扫描检测', desc: '每小时核查 50 组货架，同步完成缺货、价签、陈列检查，数据实时上传生成巡检报告。' }
      ],
      sceneList: [
        { icon: require("@/assets/product/robot/LM200/img8.png"), name: '无人零售店', desc: '无人超市、24 小时无人便利店，可完全替代人工完成全流程货架管理和安防工作，实现真正意义上的无人化运营，降低无人店运营成本。' },
        { icon: require("@/assets/product/robot/LM200/img9.png"), name: '中小型商超', desc: '社区超市、连锁便利店、精品商超，针对这类商超人力预算有限、管理半径小的特点，提供轻量化、高性价比的巡检解决方案，快速落地见效。' },
        { icon: require("@/assets/product/robot/LM200/img10.png"), name: '专业零售店', desc: '美妆店、零食店、日用百货店，针对单一品类商品特点定制巡检规则，精准解决这类店铺商品陈列要求高、价签更新频繁的管理痛点。' },

      ]
    }
  },
  methods: {
    openContactUs() {
      this.$root.$emit('openContactUs', 'LM200')
    }
  }
}
</script>

<style lang="less" scoped>
.page-box {
  background-color: #fff;
}

/* Banner 区域 */
.top-box {
  width: 100%;
  min-width: 1200px;
  height: 600px;
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: center;
  display: flex;
  justify-content: center;
}

.max-width-1920 {
  max-width: 1920px;
  width: 100%;
  padding-top: 70px;
}

.content-positioning {
  width: 1200px;
  text-align: center;
  padding-top: 100px;
}

.title-1 {
  font-weight: bold;
  font-size: 42px;
  color: #222222;
  line-height: 57px;
  letter-spacing: 1px;
  text-align: justify;
}

.title-2 {
  font-size: 24px;
  color: #222222;
  line-height: 42px;
  text-align: justify;
  margin-top: 33px;
}

.title-3 {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 180px;
  height: 50px;
  background: linear-gradient(270deg, #29ABFE 0%, #016BFF 100%);
  border-radius: 8px;
  font-weight: bold;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 16px;
  text-align: center;
  cursor: pointer;
}


/* 通用区块样式 */
.section-title {
  font-weight: bold;
  font-size: 32px;
  color: #222222;
  line-height: 34px;
  text-align: center;
  margin-bottom: 40px;
}

.section-title-small {
  font-weight: bold;
  font-size: 32px;
  color: #222222;
  line-height: 34px;
  text-align: center;
  margin-bottom: 10px;
}

.section-subtitle {
  font-size: 16px;
  color: #595859;
  line-height: 21px;
  text-align: center;
}

/* 核心能力 */
.capability-section {
  width: 100%;
  padding: 80px 0;
  background: #ffffff;
}

.capability-grid {
  width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  margin-top: 20px;
  ;
}

.capability-grid1 {
  width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-top: 20px;
  ;
}

.capability-card {
  background: linear-gradient(180deg, #FAFCFF 0%, #ECF2FF 100%);
  border-radius: 6px;
  border: 1px solid #ECF2FF;
  padding: 32px;
  text-align: center;
  transition: all 0.3s;
  flex: 1;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
  }
}

.capability-icon {
  width: 40px;
  height: 40px;
  margin-bottom: 16px;
  object-fit: contain;
}

.capability-name {
  font-size: 20px;
  font-weight: 600;
  color: #222222;
  margin-bottom: 8px;
}

.capability-desc {
  font-size: 14px;
  color: #666666;
  line-height: 22px;
}


/* 技术特点 */
.feature-section {
  width: 100%;
  padding: 80px 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 80vh; /* 视窗高度的 80% */
}



.flor3 {
  width: 100%;
  background: #F4F5FB;
  display: flex;
  flex-direction: column;
  padding: 80px 0 80px;

  .f2-title {
    font-weight: bold;
    font-size: 32px;
    color: #222222;
    line-height: 34px;
    text-align: center;
    margin-bottom: 35px;
  }

  .f2-subtitle {
    font-size: 16px;
    color: #222222;
    line-height: 30px;
    text-align: center;
    margin-bottom: 40px;
  }

  .scene-cards-container {
    width: 1200px;
    margin: 0 auto;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }

.scene-card-item {
  border-radius: 6px;
  overflow: hidden;
}

.f3-card {
  background: #ffffff;
  border-radius: 6px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.f3-card .bgimg {
  width: 100%;
  height: 240px;
  object-fit: cover;
}

.f3-card .title {
  font-weight: bold;
  font-size: 22px;
  color: #222222;
  line-height: 22px;
  text-align: left;
  padding: 20px;
  margin: 0;
}

.f3-card .subtitle {
  font-size: 14px;
  color: #222222;
  line-height: 22px;
  text-align: justify;
  padding: 0 20px 20px 20px;
  margin: 0;
  flex: 1;
}

}
</style>
